import React from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Link } from '../components/shared/simple/Link';
import { siteMap } from '../constants/routes';
import bg from '../assets/images/login/background_default.jpg';

const LinkText = styled(Link)`
  font-size: 18px;
  cursor: pointer;
	position: absolute; 
	top: 20px; 
	right: 20px;
`;
export const MainContainer = styled.div`
  position: relative;
  margin: 0;
  min-height: 100vh;
  background-image: url(${bg});
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row;
  justify-content: start;
	
  padding: 60px 0px 90px;
	@media (min-width: 767px) {
	  padding: 20px 40px 40px;
	}

`
const InnerContainer = styled.div`
	padding: 0px;
	color: white;
	width: 90%;
	height: 100%;
	margin: 0 auto !important;

	@media (min-width: 767px) {
		padding: 60px 40px;
	}

	& h1 {
		text-align: center
	}

`

const useAltModule = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleGoBack = async() => {
		if (localStorage.getItem("idRequest")){
			localStorage.removeItem("idRequest");
		}
		navigate(siteMap.homepage.path);
	};

	const BackBtn = (
		<LinkText color="third" onClick={ handleGoBack } name="link_back">
			{`< ${ t("common.backHomepage") }`}
		</LinkText>
	) 

  return {
		BackBtn,
		MainContainer,
		InnerContainer
  }
}

export default useAltModule